export const NODE_NAME = 'paragraph';
